import { render, staticRenderFns } from "./DomainWhiteList.vue?vue&type=template&id=459f6912&"
import script from "./DomainWhiteList.vue?vue&type=script&lang=js&"
export * from "./DomainWhiteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QBtn,QPagination,QInnerLoading} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QBtn,QPagination,QInnerLoading})
